import FaqContact from "app/pages/Faq/FaqFooter/FaqContact/FaqContact";
import { connect } from "react-redux";
import { getContextCallCenter } from "app/pages/Booking/bookingSelectors";

const FaqContactContainer = props => {
	return <FaqContact {...props} />;
};

const mapStateFromProps = state => {
	const contextCallCenter = getContextCallCenter({})(state);
	return {
		servicesPhone: contextCallCenter.services,
		helpContactUrl: contextCallCenter.helpContactUrl,
		preSalesPlanningUrl: state.callCenter.preSalesPlanningUrl,
		afterSalesPlanningUrl: state.callCenter.afterSalesPlanningUrl,
	};
};

export default connect(mapStateFromProps)(FaqContactContainer);
